export default "__VITE_ASSET__ecfb44ef__"